module.exports = __webpack_public_path__ + "static/molly-happy-sm-960d11e01fc651648eb86be768ecae51.png";